import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { headingFontFamily } from 'components/shared/DesignSystem/shared/styles';

// begin styled components
const Container = styled.div`
  display: flex;
  justify-content: center;
  margin-block-start: var(--cc_size_spacing_xxl);
`;
const Content = styled.div`
  max-width: 325px;
  text-align: center;
`;
const ContentBefore = styled.div`
  display: flex;
  justify-content: center;
`;
const Message = styled.p`
  margin: 0 0 var(--cc_size_spacing_xs);
  color: var(--cc_color_text_subtle);
  font-size: var(--cc_size_text_s);
  line-height: calc(var(--cc_size_text_s) + 4px);
`;
const Heading = styled.h3`
  ${headingFontFamily}
  font-size: var(--cc_size_text_l);
  margin: var(--cc_size_spacing_s) 0;
`;
// end styled components

const TrashCanMessage = ({ contentBefore, heading, message }) => {
  return (
    <Container>
      <Content>
        {contentBefore ? <ContentBefore>{contentBefore}</ContentBefore> : null}
        {heading ? <Heading>{heading}</Heading> : null}
        {message ? <Message>{message}</Message> : null}
      </Content>
    </Container>
  );
};

TrashCanMessage.propTypes = {
  contentBefore: PropTypes.node,
  heading: PropTypes.string,
  message: PropTypes.string,
};
TrashCanMessage.defaultProps = {
  contentBefore: undefined,
  heading: undefined,
  message: undefined,
};
export default TrashCanMessage;
